// Grow a textarea to its content; only scroll once `maxPx` is hit.
// scrollHeight leaves out the border, so add it back or a scrollbar shows on
// a two-line box.
export function fitTextareaHeight(el: HTMLTextAreaElement, maxPx: number) {
  el.style.height = 'auto'
  const border = el.offsetHeight - el.clientHeight
  const wanted = el.scrollHeight + border
  el.style.height = `${Math.min(wanted, maxPx)}px`
  el.style.overflowY = wanted > maxPx ? 'auto' : 'hidden'
}
